<div class="breadcrumbs">
  <span class="title">Gestione Emergenze <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon> Anagrafica Utenti <mat-icon style="vertical-align: middle;">keyboard_arrow_right</mat-icon> Crea Utente</span>
</div>
<hr>
<div class="titolo flex-display">
  <span class="h1 upp">Crea Utente</span>
</div>

<div class="form-container">
  <form [formGroup]="creaUtenteForm">

    <div class="form-section">
      <div class="form-field">
        <label for="codiceFiscale">Codice Fiscale *</label>
        <input id="codiceFiscale" type="text" formControlName="codiceFiscale">
        <div *ngIf="creaUtenteForm.get('codiceFiscale').invalid && creaUtenteForm.get('codiceFiscale').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="nome">Nome *</label>
        <input id="nome" type="text" formControlName="nome">
        <div *ngIf="creaUtenteForm.get('nome').invalid && creaUtenteForm.get('nome').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="cognome">Cognome *</label>
        <input id="cognome" type="text" formControlName="cognome">
        <div *ngIf="creaUtenteForm.get('cognome').invalid && creaUtenteForm.get('cognome').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
    </div>

    <!-- Sezione Attributi Utente -->
    <!--
    <div class="form-section">
      <h3 class="subtitle">Attributi Utente</h3>
      <div class="form-field">
        <label for="provinciaEnte">Provincia Ente *</label>
        <input id="provinciaEnte" type="text" formControlName="provinciaEnte">
        <div *ngIf="creaUtenteForm.get('provinciaEnte').invalid && creaUtenteForm.get('provinciaEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="tipologiaEnte">Tipologia Ente *</label>
        <input id="tipologiaEnte" type="text" formControlName="tipologiaEnte">
        <div *ngIf="creaUtenteForm.get('tipologiaEnte').invalid && creaUtenteForm.get('tipologiaEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="codiceIstat">Codice ISTAT *</label>
        <input id="codiceIstat" type="text" formControlName="codiceIstat">
        <div *ngIf="creaUtenteForm.get('codiceIstat').invalid && creaUtenteForm.get('codiceIstat').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="descrizione">Descrizione</label>
        <input id="descrizione" type="text" formControlName="descrizione">
      </div>
      <div class="form-field">
        <label for="indirizzoEnte">Indirizzo Ente *</label>
        <input id="indirizzoEnte" type="text" formControlName="indirizzoEnte">
        <div *ngIf="creaUtenteForm.get('indirizzoEnte').invalid && creaUtenteForm.get('indirizzoEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="capEnte">CAP Ente *</label>
        <input id="capEnte" type="text" formControlName="capEnte">
        <div *ngIf="creaUtenteForm.get('capEnte').invalid && creaUtenteForm.get('capEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="cittaEnte">Città Ente *</label>
        <input id="cittaEnte" type="text" formControlName="cittaEnte">
        <div *ngIf="creaUtenteForm.get('cittaEnte').invalid && creaUtenteForm.get('cittaEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
      <div class="form-field">
        <label for="faxEnte">Fax Ente</label>
        <input id="faxEnte" type="text" formControlName="faxEnte">
      </div>
      <div class="form-field">
        <label for="pecEnte">Pec Ente *</label>
        <input id="pecEnte" type="text" formControlName="pecEnte">
        <div *ngIf="creaUtenteForm.get('pecEnte').invalid && creaUtenteForm.get('pecEnte').touched" class="validation-message">
          Campo obbligatorio
        </div>
      </div>
    </div>
    -->

    <div class="pulsanti-container">
      <div class="pulsante-left">
        <button mat-stroked-button color="basic" class="pers2" (click)="onIndietro()">
          INDIETRO
        </button>
      </div>
      <div class="pulsante-right">
        <button mat-stroked-button class="pers2 reset-button" (click)="onReset()">
          RESET
        </button>
        <button mat-raised-button color="accent" class="pers2" (click)="onSalva()" [disabled]="isLoading">
          <span *ngIf="!isLoading">SALVA</span>
          <span *ngIf="isLoading">Salvataggio in corso...</span>
        </button>
      </div>
    </div>
  </form>
</div>
